import { useRef, useState } from 'react';
import { Paperclip, Send } from 'lucide-react';
import { Button } from '../../../shared/ui/Button';
import { useToast } from '../../../shared/hooks/useToast';
import styles from '../SupportTicketView.module.css';

export interface ComposerSubmit { body: string; files: File[]; }

export function TicketComposer({ onSend, disabled }: {
  onSend: (data: ComposerSubmit) => Promise<void>;
  disabled?: boolean;
}) {
  const [body, setBody] = useState('');
  const [files, setFiles] = useState<File[]>([]);
  const [sending, setSending] = useState(false);
  const fileRef = useRef<HTMLInputElement | null>(null);
  const toast = useToast();

  async function submit() {
    if (!body.trim() && files.length === 0) return;
    setSending(true);
    try {
      await onSend({ body: body.trim(), files });
      setBody(''); setFiles([]);
      if (fileRef.current) fileRef.current.value = '';
    } catch (e) {
      console.error('[ticket composer]', e);
      toast.error('Não foi possível enviar a mensagem.');
    } finally { setSending(false); }
  }

  return (
    <div className={styles.composer}>
      <textarea className={styles.composerInput} placeholder="Escreva uma resposta…"
        value={body} onChange={(e) => setBody(e.target.value)} rows={2} disabled={disabled || sending} />
      {files.length > 0 ? <div className={styles.composerFiles}>{files.map((f) => f.name).join(', ')}</div> : null}
      <div className={styles.composerActions}>
        <input ref={fileRef} type="file" accept="image/*,application/pdf" multiple hidden
          onChange={(e) => setFiles(Array.from(e.target.files ?? []))} />
        <button type="button" className={styles.attachBtn} onClick={() => fileRef.current?.click()}
          disabled={disabled || sending} aria-label="Anexar print"><Paperclip size={18} /></button>
        <Button onClick={submit} disabled={disabled || sending} isLoading={sending} leftIcon={<Send size={16} />}>Enviar</Button>
      </div>
    </div>
  );
}
